import {
  getUserAccountList,
  handleKeyDown,
  uploadFiles,
} from "_services";
import {
  CommonCanvas,
  CommonDatePicker,
  CommonInput,
  CustomSelect,
  SkeletonInput,
} from "components";
import { UserContext } from "context";
import { addTransationFreight } from "features";
import { errorSchema, utils } from "helper";
import AddAccountingAccount from "modals/AddAccountingAccount";
import PayNowAccountNotifyModal from "modals/PayNowAccountNotifyModal";
import React, { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { IoCloseCircle } from "react-icons/io5";
import { useDispatch } from "react-redux";
import { getAllPermissions } from "utils/permissionHelper";
import StorageService from "utils/StorageServices/StorageServices";

const FreightAdvancePay = (props) => {
  const { venderDetailsFun = () => { }, tripDetais, setIsOpenPayNow, callbackEaesbuzz, key } = props;
  const initiFrom = {
    category: "",
    sub_category: "",
    expense_category: "",
    amount: "",
    txn_date: new Date(),
    account_category: "",
    account_sub_category: "",
    account_id: "",
    description: "",
    isCheck: false,
    vendor_account: "",
    lr_id: "",
    trip_id: props?.tripId,
    branch_id: "",
    company_id: StorageService.getCompanyId(),
    vehicle_id: "",
    file: [],
  };
  const dispatch = useDispatch();
  const {
    masterData,
    globTripDetails,
    bankDetails,
    setBankDetails,
    modalZIndex,
    setModalZIndex,
    allMenu
  } = useContext(UserContext);
  const [form, setForm] = useState(initiFrom);
  const [formError, setFormError] = useState("");
  const [freightTypeList, setFreightTypeList] = useState([]);
  const [freigtAccount, setFreigtAccount] = useState([]);
  const [accountList, setAccountList] = useState([]);
  const [isCheck, setIsCheck] = useState(bankDetails ? true : false);
  const [bankAccountList, setBankAccountList] = useState([]);
  const [isLoadding, setIsLoadding] = useState(false);
  const [isLoaddingforsave, setIsLoaddingForSave] = useState(false);
  const [aprroveStatus, setAprroveStatus] = useState();
  const [accountType, setAccountType] = useState();
  const [accountLoading, setAccountLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [accountAddShow, setAccountAddShow] = useState(false);
  const [bankRequiredDetails, setBankRequiredDetails] = useState({})
  const [easeBuzzId, setEaseBuzzId] = useState("")
  const [payNowAccountCreate, setpayNowAccountCreate] = useState(false);

  const balance = props?.transactionList?.freight_summary?.balance;
  // const allPerms = getAllPermissions('/account/consignor', allMenu, 'link');
  const hasLinkPermission = getAllPermissions("Accounts", allMenu, 'label');


  function checkBalance(balance) {
    if (balance > 0) {
      return "plus";   // Positive balance
    } else if (balance < 0) {
      return "minus";  // Negative balance
    } else {
      return "zero";   // Exactly 0
    }
  }

  const styleZindex = {
    zIndex: -1,
  };
  useEffect(() => {
    let mounted = true;

    const load = async () => {
      const data = await getMasterFreight();
      if (mounted) {
        setForm(prev => ({ ...prev, ...data }));
      }
    };

    if (props?.isOpenFreight?.open) load();

    return () => {
      mounted = false;
    };
  }, [props?.isOpenFreight?.open]);


  useEffect(() => {
    if (!isCheck) {
      setBankDetails("");
      if (form?.vendor_account) {
        setForm(prev => ({ ...prev, vendor_account: "" }));
      }
    } else {

      setForm(prev => ({ ...prev, vendor_account: bankAccountList[0]?._id }));
      setFormError((pre) => ({ ...pre, vendor_account: "" }))
      setBankDetails(bankAccountList[0]);
    }
  }, [isCheck]);

  useEffect(() => {
    if (bankDetails && form?.category) {
      setForm({ ...form, vendor_account: bankDetails?._id });
      setFormError((pre) => ({ ...pre, vendor_account: "" }))
    }
  }, [bankDetails, form?.category]);

  useEffect(() => {
    if (form?.sub_category == 2) {
      setForm((prev) => {
        const updatedAmount =
          form?.sub_category == 2
            ? prev?.amount || globTripDetails?.freight_summary?.balance || 0
            : prev?.amount;

        return {
          ...prev,
          amount: updatedAmount,
        };
      });
    }
  }, [form?.sub_category]);
  useEffect(() => {
    console.log(form?.account_sub_category, form?.account_category, freigtAccount.length, form)

    if (form?.account_sub_category && form?.account_category && freigtAccount.length) {
      if (form?.account_id === "") {
        getAccountListHandler();
      }
    }
  }, [
    form?.account_sub_category,
    form?.account_category,
    freigtAccount,
    form?.account_id,
    form?.sub_category,
  ]);

  useEffect(() => {
    let value = false;

    // 1️⃣ bankRequiredDetails rule
    if (bankRequiredDetails?.vendor_account === true && form?.account_sub_category == 2) {

      value = true;
    }

    // 2️⃣ form/account rules
    if (form?.account_id === "") {
      value = false;
    }

    if (form?.account_sub_category == 27 || form?.account_sub_category == 28) {
      value = true;
    }

    // Final update in one place:
    setIsCheck(value);

  }, [
    bankRequiredDetails,
    form?.account_sub_category,
    form?.account_id,
  ]);

  useEffect(() => {
    if (accountType) {
      setForm({ ...form, account_id: "", vendor_account: "" });
      setEaseBuzzId("")
      setBankDetails("");
    }
  }, [accountType]);

  useEffect(() => {
    if (props?.accountList?.length > 0) {
      let list = props?.accountList?.map((i) => {

        return {
          ...i,
          label: i?.bank_name || i?.account_name || i?.upi_id,
          value: i?._id,
        };
      });
      setBankAccountList(list);
    }
  }, [props?.accountList]);

  const getMasterFreight = async () => {

    try {
      const details = masterData?.supplier_freights?.sub_type?.map((item) => {
        return {
          label: item?.name,
          value: item?.id,
          id: item?._id,
          status: item?.status,
          category_id: masterData?.supplier_freights?.id,
          type: masterData?.supplier_freights?.type,
        };
      });

      const detailsAccount = masterData?.market_account_category?.sub_category
        ?.filter((k) => k.id !== 10)
        .map((item) => {
          return {
            label: item?.name,
            value: item?.id,
            category_id: masterData?.market_account_category?.id,
          };
        });

      const order = [3, 2, 27, 14, 28];
      const sortedData = detailsAccount.sort(
        (a, b) => order.indexOf(a.value) - order.indexOf(b.value)
      );

      if (sortedData && details) {
        setForm({
          ...form,
          trip_id: props?.tripId,
          category:
            details[props?.isOpenFreight?.type === "freight" ? 0 : 1]
              ?.category_id,
          sub_category:
            details[props?.isOpenFreight?.type === "freight" ? 0 : 1]?.value,
          account_category: sortedData[0]?.category_id,
          account_sub_category: sortedData[0]?.value,
        });

        setFreigtAccount(sortedData);
        setFreightTypeList(details);
        setAccountType(sortedData[0]?.value);
      }
      // }
    } catch { }
  };

  const getAccountListHandler = async (newParam = "") => {

    setAccountLoading(true);
    try {
      const res = await getUserAccountList({
        company_id: StorageService?.getCompanyId(),
        category_id: parseInt(form?.account_category),
        sub_category_id: parseInt(form?.account_sub_category),
        firm_id: tripDetais?.firm_id?._id
      });

      if (res?.responseCode === 200) {
        setAccountLoading(false);
        const details = res?.data?.account_list?.map((item) => {
          return {
            ...item,
            label: item?.name,
            value: item?._id,
          };
        });

        setAccountList(details);

        if (details?.length) {
          const lastItem = details[details.length - 1];
          setForm((prev) => {
            const updatedAmount =
              prev?.sub_category == 2
                ? prev?.amount || globTripDetails?.freight_summary?.balance || 0
                : prev?.amount;

            return {
              ...prev,
              account_id: newParam == "new" ? lastItem?.value : details[0]?.value,
              amount: updatedAmount,
            };
          });


          setBankRequiredDetails(newParam == "new" ? lastItem : details[0])
          if (form?.account_sub_category == 28) {
            setEaseBuzzId(details[0]?.eb_account_id)

          } else {
            setEaseBuzzId("")
          }
        } else {

          if (details.length == 0 && form?.account_sub_category == 28) {
            setpayNowAccountCreate(true)
          }

          setForm((prev) => ({
            ...prev,
            account_id: "", // fallback or reset
          }));
        }

      } else {
        setAccountLoading(false);

        setAccountList([]);
      }
    } catch (error) {

      setAccountLoading(false);
      setAccountList([]);
    }
  };

  const handleOnChange = async (name, value) => {
    const stateObj = {
      ...form,
      [name]: value,
    };

    if (name === "isCheck") {
      stateObj.vendor_account = "";
    }
    setForm(stateObj);

    if (!!formError) {
      const validationResult = await utils.checkFormError(
        { ...stateObj, balance: balance, isCheck: isCheck, checkBalance: checkBalance(balance) },
        errorSchema.addFreigthSchema
      );
      if (validationResult === true) {
        setFormError("");
      } else {
        setFormError(validationResult);
      }
    }
  };

  const onSubmitFreight = async (approve) => {
    const validationResult = await utils.checkFormError(
      { ...form, balance: balance, isCheck: isCheck, checkBalance: checkBalance(balance) },
      errorSchema.addFreigthSchema,
    );

    const payload = {
      type: form?.category ? parseInt(form?.category) : "",
      sub_type: form?.sub_category ? parseInt(form?.sub_category) : "",
      expense_category: form?.expense_category,
      amount: (form?.amount).toString(),
      date: utils.convertToISO(form?.txn_date, true),
      account_category: form?.account_category
        ? parseInt(form?.account_category)
        : "",
      account_sub_category: form?.account_sub_category
        ? parseInt(form?.account_sub_category)
        : "",
      account_id: form?.account_id ? form?.account_id : "",
      description: form?.description,
      vendor_bank_account: bankDetails ? bankDetails?._id : "",
      lr_id: form?.lr_id,
      trip_id: props.tripId,
      branch_id: globTripDetails?.branch_id?._id,
      company_id: form?.company_id,
      vehicle_id: globTripDetails?.vehicle_id?._id,
      is_approval: approve,
      file: form?.file,
      nature_type: form.sub_category == 2 ? checkBalance(balance) === "plus" ? 1 : 2 : 1
    };

    if (validationResult === true) {
      if (approve == 0 && form?.account_sub_category == 28) {
        callbackEaesbuzz(
          easeBuzzId,
          form?.amount,
          {
            vendor_bank_account: {
              account_name: bankDetails?.account_name,
              account_number: bankDetails?.account_number,
              account_type: bankDetails?.account_type,
              bank_name: bankDetails?.bank_name,
              ifsc_code: bankDetails?.ifsc_code,
              upi_id: bankDetails?.upi_id
            }
          },
          payload
        );
        setIsOpenPayNow(true)
        return
      }

      if (approve == 0) {
        setIsLoaddingForSave(true);
      } else {
        setIsLoadding(true);
      }
      setFormError(validationResult);

      try {
        const res = await dispatch(addTransationFreight(payload));
        if (res?.payload?.responseCode === 200) {
          setIsLoadding(false);
          setIsLoaddingForSave(false);

          props?.callBackFreight();
          closeAll();
        } else {
          setIsLoadding(false);
          setIsLoaddingForSave(false);
        }
      } catch {
        setIsLoaddingForSave(false);
        setIsLoadding(false);
      }
    } else {
      setFormError(validationResult);
      setIsLoaddingForSave(false);
      setIsLoadding(false);
    }
  };

  const closeAll = async () => {
    setBankDetails("");
    props?.setIsOpenFreight({ ...props?.isOpenFreight, open: false, type: "" });
    setForm(initiFrom);
  };

  const modifyProps = {
    ...props,
    onSubmit: onSubmitFreight,
    closeModal: closeAll,
    disabled:
      aprroveStatus == 0
        ? isLoaddingforsave
        : isLoadding,

    modalZIndex: modalZIndex,
    // sendFor: SendFor,
    isLoaddingforsave: isLoaddingforsave,
    isLoadding: isLoadding,
    saveButton: form?.account_sub_category == 27,
    tripApprovalPermission: bankRequiredDetails?.trip_payment_approval || 0,
    submitTitle: form?.account_sub_category == 28 ? "Pay Now" : "Add Freight"
  };

  const handleFileChange = async (e) => {
    if (
      e?.target?.files[0]?.type === "image/gif" ||
      e?.target?.files[0]?.type === "image/jpeg" ||
      e?.target?.files[0]?.type === "image/png"
    ) {
      setLoading(true);
      try {
        const formData = new FormData();
        formData.append("file", e?.target?.files[0]);
        const res = await uploadFiles(formData);
        if (res?.responseCode === 200) {
          var fileArray = [];
          fileArray.push(...form?.file, {
            filename: res?.data?.filename,
            path: res?.data?.path,
          });
          handleOnChange("file", fileArray);
          // setFormValue((s) => ({ ...s, file: fileArray }));
          setLoading(false);
          toast.success("Document added ");
        }
      } catch (error) {
        setLoading(false);
      }
    } else {
      toast.error("Invalid file, choose jpeg/png images");
    }
  };

  const documentRemove = (index) => {
    const newFromIput = [...form?.file];

    newFromIput.splice(index, 1);

    setForm({ ...form, file: newFromIput });
  };

  const addAccountHandle = () => {
    setAccountAddShow(true);
  };

  const callBackAddAccount = () => {
    getAccountListHandler("new")
  }

  let AddTransactionAccountModal = {
    isOpen: accountAddShow,
    closeModal: (e) => setAccountAddShow(false),
    modalMainClass: "_dashCommon_Modal _mdModal",
    modalTitle: "Add Account ",
    // headerPart: true,
    footerPart: true,
    submitTitle: "Add Account",
    callBackAddAccount: callBackAddAccount
  }

  let payNowAccountProps = {
    isOpen: payNowAccountCreate,
    closeModal: (e) => {
      setpayNowAccountCreate(false)
      setAccountType(3);
      setForm((pre) => ({ ...pre, account_sub_category: 3 }));
    },
    modalMainClass: "_dashCommon_Modal _mdModal",
    modalTitle: "Pay Now ",
    // headerPart: true,
    footerPart: true,
    submitTitle: "Create Account",
    callBackAddAccount: callBackAddAccount
  }
  return (
    <div>
      <CommonCanvas {...modifyProps}>
        <div className="offcanvas-body" key={key}>
          <div className="_lrCl_offCavBody __otr_expCanva">
            <div className="_othrExp_recBx">
              <div className="_clPay_flex">

                <div className="singleDiv">
                  <CommonDatePicker
                    name="date"
                    label="Transaction Date"
                    startDate={form?.txn_date}
                    setStartDate={(data) => {
                      handleOnChange("txn_date", data);
                    }}
                    error={formError?.txn_date}
                    focus={!!formError?.txn_date}
                    maxDate={new Date()}
                  />
                </div>

                {freightTypeList.map((i) => {

                  return (
                    <div className="_dualCheckr_bx" key={i?.value}>
                      <input
                        className="form-check-input"
                        id={i?.value}
                        type="radio"
                        name="sub_category"
                        checked={i.value == form.sub_category}
                        value={i.value}
                        onChange={({ target: { name, value } }) =>
                          handleOnChange(name, value)
                        }
                      />
                      <label htmlFor={i?.value} className="form-check-label">
                        {i?.value == 2 ? checkBalance(balance) == "plus" ? "Pay Balance" : "Receive Balance" : "Pay Advance"}

                      </label>
                    </div>
                  );
                })}

                <div className="singleDiv">
                  <CommonInput
                    label="Description"
                    name="description"
                    value={form?.description}
                    onChange={({ target: { name, value } }) =>
                      handleOnChange(name, value)
                    }
                    focus={!!formError?.description}
                    error={formError.description}
                  />
                </div>

                <div className="singleDiv">
                  <CommonInput
                    label="Amount"
                    placeholder="Amount "
                    name="amount"
                    type="text"
                    className="__rupeeSymbol"
                    rupeeSymbol={true}
                    value={form.amount || ""}
                    onChange={({ target: { name, value } }) => {
                      if (/^0[0-9]/.test(value)) {
                        value = value.replace(/^0+/, ''); // "01" → "1"
                      }

                      // Allow "0." for decimals but not "0x" where x is digit
                      if (value === "0") {
                        handleOnChange(name, value);
                        return;
                      }
                      handleOnChange(name, value)
                    }}
                    maxLength={10}
                    onKeyDown={handleKeyDown}
                    focus={!!formError?.amount}
                    error={formError.amount}
                  />
                </div>

              </div>
            </div>

            <div className="_othrExp_recBx">
              <div className="_clPay_flex">
                <div className="singleDiv">
                  <div className="_payMode_hed">
                    <h4>Payment Mode</h4>
                    {freigtAccount.map((i) => (
                      <button
                        className={`_baseSpan ${i?.value == form?.account_sub_category
                          ? ""
                          : "_bspDisable"
                          }`}
                        name="account_sub_category"
                        disabled={accountLoading}
                        value={i.value}
                        onClick={({ target: { name, value } }) => {
                          setAccountType(value);
                          handleOnChange(name, value);

                          if (value == 2 || value == 27 || value == 28) {
                            venderDetailsFun({ vender_type: 1, vender_id: globTripDetails?.supplier_id?._id })
                          }
                        }}
                      >
                        {i.label}
                      </button>
                    ))}

                  </div>
                </div>
                <div className="singleDiv">
                  {!accountLoading ? (
                    <CustomSelect
                      label="Select Account"
                      isDropdownTop={true}
                      name="account_id"
                      onSelect={(data) => {
                        handleOnChange("account_id", data.value)
                        setBankRequiredDetails(data)
                      }
                      }
                      value={
                        form?.account_id
                          ? accountList?.find((i) => i.value == form?.account_id)
                          : { label: "", value: "" }
                      }
                      options={accountList}
                      focus={!!formError?.account_id}
                      error={formError.account_id}
                      isAddButton={hasLinkPermission?.canCreate ? form?.account_sub_category == 2 ? true : false : false}
                      addButtonAction={addAccountHandle}
                    />
                  ) : (
                    <SkeletonInput isLoading={accountLoading} />
                  )}
                </div>
                {(form?.account_sub_category == 2 || form?.account_sub_category == 27 || form?.account_sub_category == 28) && (
                  <div>
                    <input
                      type="checkbox"
                      id="vehicle1"
                      name="vehicle1"
                      // value="Bike"
                      checked={isCheck}
                      disabled={form?.account_sub_category == 27 || form?.account_sub_category == 28 || bankRequiredDetails?.vendor_account === true}
                      onChange={({ target: { name, checked } }) => {
                        setIsCheck(checked);
                        handleOnChange("isCheck", checked);
                      }}

                    />
                    <label for="vehicle1"> Select Supplier Bank Account</label>
                    <br />
                  </div>
                )}
                {(form?.account_sub_category == 2 || form?.account_sub_category == 27 || form?.account_sub_category == 28) && isCheck && (
                  <div className="singleDiv"
                    onClick={() => {
                      // props?.setIsOpenFreight(false);
                      setModalZIndex(-1);
                      props?.setCanvasOpen(true);
                    }}
                  >
                    <CustomSelect
                      label="Select Supplier Account"
                      options={bankAccountList}
                      disabled={!isCheck}
                      openList={false}
                      value={
                        bankDetails
                          ? bankAccountList?.find(
                            (i) => i?.value === bankDetails?._id
                          )
                          : { label: "", value: "" }
                      }
                      focus={!!formError?.vendor_account}
                      error={formError.vendor_account}
                    />
                  </div>
                )}
              </div></div>
            <div className="_othrExp_recBx">
              <div className="_clPay_flex">
                <div className="singleDiv">
                  <div className="_attatchmentBxs">
                    <div className="__addExp_fileBx">
                      <h4>Attachment</h4>
                      <input
                        type="file"
                        id="_fileUpload"
                        onClick={(e) => {
                          if (form?.file?.length >= 5) {
                            e.preventDefault(); // stop opening file dialog
                            toast.error("You can upload only 5 files");
                          }
                        }}
                        onChange={(e) => handleFileChange(e)}
                      />
                      <label htmlFor="_fileUpload" className="_uploadBtn">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="19"
                          viewBox="0 0 20 19"
                          fill="none"
                        >
                          <path
                            d="M5 0C6.28846 7.44425e-05 7.52716 0.497542 8.45778 1.38866C9.38839 2.27978 9.93908 3.49575 9.995 4.783L10 5V16C10.0008 16.7809 9.69698 17.5313 9.15323 18.0918C8.60948 18.6523 7.86861 18.9787 7.08804 19.0016C6.30747 19.0245 5.54873 18.7422 4.97303 18.2145C4.39733 17.6869 4.05006 16.9556 4.005 16.176L4 16V6C4.00028 5.74512 4.09788 5.49997 4.27285 5.31463C4.44782 5.1293 4.68695 5.01776 4.94139 5.00283C5.19584 4.98789 5.44638 5.07067 5.64183 5.23426C5.83729 5.39785 5.9629 5.6299 5.993 5.883L6 6V16C6.00028 16.2549 6.09788 16.5 6.27285 16.6854C6.44782 16.8707 6.68695 16.9822 6.94139 16.9972C7.19584 17.0121 7.44638 16.9293 7.64183 16.7657C7.83729 16.6021 7.9629 16.3701 7.993 16.117L8 16V5C8.00075 4.21909 7.69698 3.46867 7.15323 2.90818C6.60948 2.34769 5.86861 2.02132 5.08804 1.9984C4.30747 1.97548 3.54873 2.25784 2.97303 2.78546C2.39733 3.31309 2.05006 4.0444 2.005 4.824L2 5V14C1.99972 14.2549 1.90212 14.5 1.72715 14.6854C1.55218 14.8707 1.31305 14.9822 1.05861 14.9972C0.804163 15.0121 0.553621 14.9293 0.358167 14.7657C0.162714 14.6021 0.0371036 14.3701 0.00699997 14.117L0 14V5C0 3.67392 0.526784 2.40215 1.46447 1.46447C2.40215 0.526784 3.67392 0 5 0ZM13 14H15C15.2549 14.0003 15.5 14.0979 15.6854 14.2728C15.8707 14.4478 15.9822 14.687 15.9972 14.9414C16.0121 15.1958 15.9293 15.4464 15.7657 15.6418C15.6021 15.8373 15.3701 15.9629 15.117 15.993L15 16H13C12.7451 15.9997 12.5 15.9021 12.3146 15.7272C12.1293 15.5522 12.0178 15.313 12.0028 15.0586C11.9879 14.8042 12.0707 14.5536 12.2343 14.3582C12.3979 14.1627 12.6299 14.0371 12.883 14.007L13 14ZM13 10H18.5C18.7549 10.0003 19 10.0979 19.1854 10.2728C19.3707 10.4478 19.4822 10.687 19.4972 10.9414C19.5121 11.1958 19.4293 11.4464 19.2657 11.6418C19.1021 11.8373 18.8701 11.9629 18.617 11.993L18.5 12H13C12.7451 11.9997 12.5 11.9021 12.3146 11.7272C12.1293 11.5522 12.0178 11.313 12.0028 11.0586C11.9879 10.8042 12.0707 10.5536 12.2343 10.3582C12.3979 10.1627 12.6299 10.0371 12.883 10.007L13 10ZM13 6H18.5C18.7549 6.00028 19 6.09788 19.1854 6.27285C19.3707 6.44782 19.4822 6.68695 19.4972 6.94139C19.5121 7.19584 19.4293 7.44638 19.2657 7.64183C19.1021 7.83729 18.8701 7.9629 18.617 7.993L18.5 8H13C12.7451 7.99972 12.5 7.90212 12.3146 7.72715C12.1293 7.55218 12.0178 7.31305 12.0028 7.05861C11.9879 6.80416 12.0707 6.55362 12.2343 6.35817C12.3979 6.16271 12.6299 6.0371 12.883 6.007L13 6ZM13 2H18.5C18.7549 2.00028 19 2.09788 19.1854 2.27285C19.3707 2.44782 19.4822 2.68695 19.4972 2.94139C19.5121 3.19584 19.4293 3.44638 19.2657 3.64183C19.1021 3.83729 18.8701 3.9629 18.617 3.993L18.5 4H13C12.7451 3.99972 12.5 3.90212 12.3146 3.72715C12.1293 3.55218 12.0178 3.31305 12.0028 3.05861C11.9879 2.80416 12.0707 2.55362 12.2343 2.35817C12.3979 2.16271 12.6299 2.0371 12.883 2.007L13 2Z"
                            fill="#1956F6"
                          />
                        </svg>
                        <span>{loading ? "Uploadding" : "Add File"}</span>
                      </label>
                      {formError?.file && (
                        <span className="input_drop_error">
                          {formError?.file}
                        </span>
                      )}
                    </div>
                    <div className="img_fnex_src">
                      {form?.file?.length > 0 &&
                        form?.file?.map((el, index) => {
                          return (
                            <>
                              <div className="pos-relative">
                                <img
                                  className="_pdfIcon_sigxe"
                                  src={`${masterData?.s3_url}${el?.path}`}
                                  alt=""
                                />
                                <span className="_clDel_icon">
                                  <IoCloseCircle
                                    onClick={() => documentRemove(index)}
                                  />
                                </span>
                              </div>
                            </>
                          );
                        })}
                    </div>
                  </div>
                </div>
                <div className="singleDiv">
                  <div className="_balSuccess">
                    <p>Balance</p>

                    <p>
                      {(
                        (() => {
                          const bal = parseFloat(balance) || 0;
                          const amt = parseFloat(form?.amount) || 0;
                          const updatedAmount = Math.abs(amt);
                          return form?.sub_category == 2
                            ? bal == 0 ? bal + updatedAmount : (checkBalance(bal) === "minus" ? bal + updatedAmount : bal - updatedAmount)
                            : bal - updatedAmount;
                        })()
                      ).toFixed(2)}

                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </CommonCanvas>

      {accountAddShow && <AddAccountingAccount {...AddTransactionAccountModal} />}
      {payNowAccountCreate && <PayNowAccountNotifyModal {...payNowAccountProps} />}
    </div>
  );
};

export default FreightAdvancePay;
